<button [type]="type" [attr.form]="form" [disabled]="disabled" [class]="'btn btn-' + variant + ' btn-' + color + ' btn-' + size">
  <ng-content></ng-content>
</button>